import { Badge } from "@/components/ui/badge";
import { Globe, Server, Landmark, Search, Zap } from "lucide-react";
import { cn } from "@/lib/utils";
import { getSourceLabel } from "@/lib/jobUtils";

const SOURCE_TYPE_CONFIG: Record<string, {
  label: string;
  icon: typeof Globe;
  className: string;
}> = {
  ats: {
    label: "ATS",
    icon: Server,
    className: "bg-blue-100 text-blue-700 border-blue-200 dark:bg-blue-900/30 dark:text-blue-300 dark:border-blue-800",
  },
  ats_feed: {
    label: "ATS",
    icon: Server,
    className: "bg-blue-100 text-blue-700 border-blue-200 dark:bg-blue-900/30 dark:text-blue-300 dark:border-blue-800",
  },
  specialized: {
    label: "Especializado",
    icon: Zap,
    className: "bg-green-100 text-green-700 border-green-200 dark:bg-green-900/30 dark:text-green-300 dark:border-green-800",
  },
  government: {
    label: "Governo",
    icon: Landmark,
    className: "bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-900/30 dark:text-amber-300 dark:border-amber-800",
  },
  aggregator: {
    label: "Agregador",
    icon: Search,
    className: "bg-muted text-muted-foreground border-border",
  },
};

interface SourceBadgeProps {
  sourceName: string | null | undefined;
  sourceType?: string | null;
  size?: "sm" | "md";
  showSourceName?: boolean;
  className?: string;
}

export function SourceBadge({
  sourceName,
  sourceType,
  size = "md",
  showSourceName = true,
  className,
}: SourceBadgeProps) {
  if (!sourceName) return null;

  const typeConfig = SOURCE_TYPE_CONFIG[sourceType ?? ""] ?? {
    label: "Externo",
    icon: Globe,
    className: "bg-muted text-muted-foreground border-border",
  };

  const Icon = typeConfig.icon;
  const displayLabel = showSourceName
    ? getSourceLabel(sourceName)
    : typeConfig.label;

  return (
    <Badge
      variant="outline"
      className={cn(
        "gap-1 font-medium border",
        typeConfig.className,
        size === "sm" && "text-[10px] px-1.5 py-0.5",
        size === "md" && "text-xs px-2 py-0.5",
        className,
      )}
    >
      <Icon className={cn(size === "sm" ? "h-3 w-3" : "h-3.5 w-3.5")} />
      {displayLabel}
    </Badge>
  );
}

export { SOURCE_TYPE_CONFIG };
